import { observer } from "mobx-react-lite";

import { CustomButton } from "ui";
import { useStores } from "stores";
import { isStatusIncluded } from "utils";
import { BID_REQUEST_STATUS_ENUM } from "interfaces";
import { RefundCurrencyModal } from "./RefundCurrencyModal";

export const RefundCurrencyButton = observer(() => {
  const { actionModals, bidCard } = useStores();

  const disabledButton = +bidCard.bid.balance!.native < 0.00001;

  const refundingStatus = isStatusIncluded(bidCard.bid.status, [
    BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDING,
    BID_REQUEST_STATUS_ENUM.AML_FAILED_REFUNDING,
  ]);

  const refundCurrencyHandler = () => {
    actionModals.open(() => <RefundCurrencyModal />, {
      title: "Подтвердите возврат",
      width: "700px",
      noValidation: true,
      isOverlayClose: false,
      onClose: () => actionModals.closeAll(),
    });
  };

  return (
    <CustomButton
      type="primary"
      onClick={refundCurrencyHandler}
      disabled={disabledButton}
      loading={refundingStatus}
      tooltip={
        refundingStatus
          ? "Транзакция в обработке"
          : disabledButton
            ? `Недостаточно ${bidCard.bid.network ?? "средств"} для осуществления возврата. Пополните кошелек`
            : "На транзитном кошельке остались средства. Произвести возврат"
      }
    >
      Сделать возврат
    </CustomButton>
  );
});
